<template>
  <div class="personnelPage">
     <Slider></Slider>
     <Header></Header>
     <Personnel></Personnel>
  </div>
   
  </el-container>
</template>
<script>
  import Slider from '@/components/layout/slider.vue';
  import Header from '@/components/layout/header.vue';
  import Personnel from '../personnel.vue';

    export default {
        data() {
            return {
              
            }
        },

        components:{
          Header,Slider,Personnel
        }
    }
</script>


<style scoped lang="scss">
  .aside{
    float: left;
  }
  .el-header{
    margin-left: 2.87rem;
    /*position: relative;*/
    }
  .personnel{
    float: left;
    margin: 0.22rem 0 0 0.31rem;
    /*position: absolute;
    top: 1rem;
    left: 3.18rem;*/
  }
</style>




// WEBPACK FOOTER //
// src/views/personnelPage/Personnel.vue